<!-- General Search View -->
<div class="general-search-page" *ngIf="_showGeneralSearch">
  <ddc-general-search-dialog></ddc-general-search-dialog>
</div>

<!-- Filter Search View -->
<div
  class="filter-search-page"
  *ngIf="_isFilterMode"
  [ngClass]="{ 'dark-theme': _isDarkTheme, 'light-theme': _isLightTheme, 'paper-theme': _isPaperTheme }"
>
  <!-- Back to General Search Button -->
  <div class="back-to-search" (click)="toggleFilterMode()">
    <button mat-icon-button>
      <mat-icon>arrow_back</mat-icon>
    </button>
    <span>Back to Search</span>
  </div>

  <!-- Search Input Section -->
  <div class="search-input-section">
    <mat-form-field class="search-input-field" appearance="fill">
      <mat-label>Searched Term</mat-label>
      <input
        #searchInput
        autocomplete="off"
        disabled="true"
        matInput
        placeholder="Search words, pairs, dictionaries, users..."
        [(ngModel)]="_searchTerm"
        (ngModelChange)="onSearchChange()"
      />
      <!-- <mat-icon matSuffix>search</mat-icon> -->
    </mat-form-field>
    <!-- Results Summary -->
    <div class="results-summary" *ngIf="!_loading && _searchTerm && _searchTerm.length >= 2 && _totalResults > 0">
      <div class="summary-item">
        <span class="count">{{ _totalResults }}</span>
        <span class="label">{{
          _totalResults === 1 ? getSingularLabel(_selectedTab) : getPluralLabel(_selectedTab)
        }}</span>
      </div>
    </div>
  </div>

  <!-- Search Tabs -->
  <div class="search-tabs">
    <button class="search-tab" [class.active]="_selectedTab === 'words'" (click)="onTabChange('words')">
      <mat-icon class="tab-icon">fiber_manual_record</mat-icon>
      <span class="tab-label">Words</span>
    </button>

    <button class="search-tab" [class.active]="_selectedTab === 'pairs'" (click)="onTabChange('pairs')">
      <mat-icon class="tab-icon">fiber_smart_record</mat-icon>
      <span class="tab-label">Pairs</span>
    </button>

    <button class="search-tab" [class.active]="_selectedTab === 'dictionaries'" (click)="onTabChange('dictionaries')">
      <mat-icon class="tab-icon">auto_stories</mat-icon>
      <span class="tab-label">Dictionaries</span>
    </button>

    <button class="search-tab" [class.active]="_selectedTab === 'users'" (click)="onTabChange('users')">
      <mat-icon class="tab-icon">person</mat-icon>
      <span class="tab-label">Users</span>
    </button>

    <button class="search-tab" [class.active]="_selectedTab === 'notes'" (click)="onTabChange('notes')">
      <mat-icon class="tab-icon">sticky_note_2</mat-icon>
      <span class="tab-label">Notes</span>
    </button>

    <button class="search-tab" [class.active]="_selectedTab === 'quizzes'" (click)="onTabChange('quizzes')">
      <mat-icon class="tab-icon">quiz</mat-icon>
      <span class="tab-label">Quizzes</span>
    </button>

    <button class="search-tab" [class.active]="_selectedTab === 'figures'" (click)="onTabChange('figures')">
      <mat-icon class="tab-icon">image</mat-icon>
      <span class="tab-label">Figures</span>
    </button>
  </div>

  <!-- Filter Toggle Button -->
  <div class="filter-toggle" *ngIf="_searchTerm && (_selectedTab === 'words' || _selectedTab === 'pairs')">
    <button color="primary" mat-raised-button [class.active]="_showFilters" (click)="toggleFilters()">
      <mat-icon>{{ _showFilters ? 'filter_alt_off' : 'filter_alt' }}</mat-icon>
      {{ _showFilters ? 'Hide Filters' : 'Show Filters' }}
      <span class="filter-count" *ngIf="getActiveFiltersCount() > 0">({{ getActiveFiltersCount() }})</span>
    </button>
  </div>

  <!-- Filter Panel -->
  <div class="filter-panel" *ngIf="_showFilters && (_selectedTab === 'words' || _selectedTab === 'pairs')">
    <div class="filter-panel-content">
      <div class="filter-section">
        <div class="filter-header">
          <h3>Filters</h3>
          <div class="filter-actions">
            <button mat-button (click)="clearAllFilters()">
              <mat-icon>clear</mat-icon>
              Clear All
            </button>
          </div>
        </div>

        <!-- Words Filters -->
        <div class="filter-columns" *ngIf="_selectedTab === 'words'">
          <div class="filter-column">
            <!-- Language Filter -->
            <mat-form-field class="filter-field">
              <mat-label><mat-icon>language</mat-icon>&nbsp;&nbsp;Language</mat-label>
              <mat-select
                [(value)]="_selectedFilters.language"
                (selectionChange)="onLanguageFilterChange($event.value)"
              >
                <mat-option *ngFor="let language of _filterOptions.languages" [value]="language.raw_value">
                  {{ language.view_value }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Article Filter -->
            <mat-form-field class="filter-field">
              <mat-label>Article</mat-label>
              <mat-select
                [disabled]="!_selectedLngHasArticle"
                [(value)]="_selectedFilters.article"
                (selectionChange)="onArticleFilterChange($event.value)"
              >
                <mat-option *ngFor="let article of _filterOptions.articles" [value]="article.raw_value">
                  {{ article.view_value }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Part of Speech Filter -->
            <mat-form-field class="filter-field">
              <mat-label>Part of Speech</mat-label>
              <mat-select
                [(value)]="_selectedFilters.partOfSpeech"
                (selectionChange)="onPartOfSpeechFilterChange($event.value)"
              >
                <mat-option *ngFor="let pos of _filterOptions.partOfSpeeches" [value]="pos.raw_value">
                  {{ pos.view_value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <!-- Pairs Filters -->
        <div class="filter-columns" *ngIf="_selectedTab === 'pairs'">
          <div class="filter-column">
            <h4>First Word</h4>
            <!-- Language 1 Filter -->
            <mat-form-field class="filter-field">
              <mat-label><mat-icon>language</mat-icon>&nbsp;&nbsp;Language</mat-label>
              <mat-select
                [(value)]="_selectedFilters.language1"
                (selectionChange)="onLanguage1FilterChange($event.value)"
              >
                <mat-option *ngFor="let language of _filterOptions.languages" [value]="language.raw_value">
                  {{ language.view_value }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Article 1 Filter -->
            <mat-form-field class="filter-field">
              <mat-label>Article</mat-label>
              <mat-select
                [disabled]="!_selectedLngHasArticle"
                [(value)]="_selectedFilters.article1"
                (selectionChange)="onArticleFilterChange($event.value)"
              >
                <mat-option *ngFor="let article of _filterOptions.articles" [value]="article.raw_value">
                  {{ article.view_value }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Part of Speech 1 Filter -->
            <mat-form-field class="filter-field">
              <mat-label>Part of Speech</mat-label>
              <mat-select
                [(value)]="_selectedFilters.partOfSpeech1"
                (selectionChange)="onPartOfSpeechFilterChange($event.value)"
              >
                <mat-option *ngFor="let pos of _filterOptions.partOfSpeeches" [value]="pos.raw_value">
                  {{ pos.view_value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="filter-column">
            <h4>Second Word</h4>
            <!-- Language 2 Filter -->
            <mat-form-field class="filter-field">
              <mat-label><mat-icon>language</mat-icon>&nbsp;&nbsp;Language</mat-label>
              <mat-select
                [(value)]="_selectedFilters.language2"
                (selectionChange)="onLanguage2FilterChange($event.value)"
              >
                <mat-option *ngFor="let language of _filterOptions.languages2" [value]="language.raw_value">
                  {{ language.view_value }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Article 2 Filter -->
            <mat-form-field class="filter-field">
              <mat-label>Article</mat-label>
              <mat-select
                [disabled]="!_selectedLngHasArticle2"
                [(value)]="_selectedFilters.article2"
                (selectionChange)="onArticle2FilterChange($event.value)"
              >
                <mat-option *ngFor="let article of _filterOptions.articles2" [value]="article.raw_value">
                  {{ article.view_value }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Part of Speech 2 Filter -->
            <mat-form-field class="filter-field">
              <mat-label>Part of Speech</mat-label>
              <mat-select
                [(value)]="_selectedFilters.partOfSpeech2"
                (selectionChange)="onPartOfSpeech2FilterChange($event.value)"
              >
                <mat-option *ngFor="let pos of _filterOptions.partOfSpeeches2" [value]="pos.raw_value">
                  {{ pos.view_value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Results Container -->
  <div class="results-container">
    <!-- Loading State -->
    <div class="loading-state" *ngIf="_loading">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Searching...</p>
    </div>

    <!-- Empty State - No Search Term -->
    <div class="empty-state" *ngIf="!_searchTerm && !_loading">
      <mat-icon>search</mat-icon>
      <h3>Start searching</h3>
      <p>Enter a search term to find {{ _selectedTab }} across the platform</p>
    </div>

    <!-- Empty State - No Results -->
    <div class="empty-state" *ngIf="_searchTerm && _results.length === 0 && !_loading">
      <mat-icon>search_off</mat-icon>
      <h3>No results found</h3>
      <p>Try different keywords or adjust your filters</p>
    </div>

    <!-- Results List -->
    <div
      class="results-list"
      *ngIf="_results.length > 0 && !_loading"
      infiniteScroll
      [infiniteScrollDistance]="1"
      [infiniteScrollThrottle]="500"
      (scrolled)="onScroll()"
    >
      <!-- Result Items -->
      <div
        class="result-item"
        *ngFor="let result of _results; let i = index"
        [class.dictionary-result]="result.type === 'dictionary'"
        [class.figure-result]="result.type === 'figure'"
        [class.note-result]="result.type === 'note'"
        [class.pair-result]="result.type === 'pair'"
        [class.quiz-result]="result.type === 'quiz'"
        [class.user-result]="result.type === 'user'"
      >
        <div class="result-icon" *ngIf="result.type !== 'user'">
          <mat-icon>{{
            result.type === 'word'
              ? 'fiber_manual_record'
              : result.type === 'pair'
                ? 'fiber_smart_record'
                : result.type === 'dictionary'
                  ? 'auto_stories'
                  : result.type === 'note'
                    ? 'sticky_note_2'
                    : result.type === 'quiz'
                      ? 'quiz'
                      : result.type === 'figure'
                        ? 'image'
                        : 'person'
          }}</mat-icon>
        </div>

        <div class="result-content">
          <div class="result-title">
            <!-- Word Result -->
            <ddc-search-result-word
              *ngIf="result.type === 'word'"
              [result]="result"
              [showIcon]="false"
              [showTime]="false"
              (wordClick)="openReadWordDialog($event)"
            >
            </ddc-search-result-word>

            <!-- Pair Result -->
            <ddc-search-result-pair
              *ngIf="result.type === 'pair'"
              [result]="result"
              [showIcon]="false"
              [showTime]="false"
              (pairClick)="openReadPairDialog($event)"
            >
            </ddc-search-result-pair>

            <!-- Dictionary Result -->
            <ddc-search-result-dictionary
              *ngIf="result.type === 'dictionary'"
              [result]="result"
              [showIcon]="false"
              [showTime]="false"
              (dictionaryClick)="navigateToDictionary($event)"
            >
            </ddc-search-result-dictionary>

            <!-- User Result -->
            <ddc-search-result-user
              *ngIf="result.type === 'user'"
              [_DefaultProfilePic]="_DefaultProfilePic"
              [result]="result"
              [showIcon]="false"
              [showTime]="false"
              (userClick)="navigateToUser($event)"
            >
            </ddc-search-result-user>

            <!-- Note Result -->
            <ddc-search-result-note
              *ngIf="result.type === 'note'"
              [result]="result"
              [showIcon]="false"
              [showTime]="false"
              (noteClick)="navigateToNote($event)"
            >
            </ddc-search-result-note>

            <!-- Quiz Result -->
            <ddc-search-result-quiz
              *ngIf="result.type === 'quiz'"
              [result]="result"
              [showIcon]="false"
              [showTime]="false"
              (quizClick)="navigateToQuiz($event)"
            >
            </ddc-search-result-quiz>

            <!-- Figure Result -->
            <ddc-search-result-figure
              *ngIf="result.type === 'figure'"
              [result]="result"
              [showIcon]="false"
              [showTime]="false"
              (figureClick)="navigateToFigure($event)"
            >
            </ddc-search-result-figure>
          </div>
        </div>

        <div class="result-time" *ngIf="result.time_since_creation">
          {{ result.time_since_creation }}
        </div>
      </div>

      <!-- Load More Indicator -->
      <div class="load-more-indicator" *ngIf="_loadingMore">
        <mat-spinner diameter="30"></mat-spinner>
        <span>Loading more results...</span>
      </div>

      <!-- End of Results -->
      <div class="end-indicator" *ngIf="!_hasMoreResults && _results.length > 0">
        <mat-icon>fact_check</mat-icon>
        <span>All results loaded</span>
      </div>
    </div>
  </div>
</div>
